import { render, staticRenderFns } from "./ABAddOrEdit.vue?vue&type=template&id=242944a8&scoped=true"
import script from "./ABAddOrEdit.vue?vue&type=script&lang=js"
export * from "./ABAddOrEdit.vue?vue&type=script&lang=js"
import style0 from "./ABAddOrEdit.vue?vue&type=style&index=0&id=242944a8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "242944a8",
  null
  
)

export default component.exports